import $clamp from "clamp-js-main";

document.addEventListener("DOMContentLoaded", () => {
  const productCardTitles = document.querySelectorAll(".product-card__title");
  productCardTitles.forEach((title) => {
    $clamp(title, 2);
  });

  const productQuickAddTitle = document.querySelector(
    ".product-quick-add__title"
  );

  if (productQuickAddTitle) {
    $clamp(productQuickAddTitle, 2);
  }
});
